import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import BetDetailsShowCombinations from "./BetDetailsShowCombinations";
import MaxGain from "./details-items/MaxGain";
import Payment from "./details-items/Payment";
import Gain from "./details-items/Gain";
import Payout from "./details-items/Payout";

import { FiscalizationSection } from "@components/fiscalization/desktop/FiscalizationSection";

export default observer(function BetDetails(props: {
	setShowCombinations: (v: boolean) => void;
}) {
	const { t } = useTranslation("mybets");
	const bet = useContext(MyBetsBetContext);
	const betStore = useContext(MyBetsStoreContext);

	if (betStore == null) {
		return null;
	}

	const {
		betCancelStore: { onBetCancel },
	} = betStore;

	return (
		<tr className="table--bets__details">
			<td className="u-padd--reset" colSpan={8}>
				<table
					className="table--bets--reset"
					cellSpacing={0}
					cellPadding={0}
				>
					<tbody>
						<tr className="table--bets__tr">
							<td className="table--bets__dd">
								{t("ITEM.ADDITIONAL_NUM_SELECTED_EVENTS")}
							</td>
							<td className="table--bets__dd">
								{bet.eventCount}
							</td>
						</tr>
						<tr className="table--bets__tr">
							<BetDetailsShowCombinations
								setShowCombinations={props.setShowCombinations}
							/>
						</tr>
						<tr className="table--bets__tr">
							<td className="table--bets__dd">
								{t("ITEM.ADDITIONAL_STAKE_PER_BET")}
							</td>
							<td className="table--bets__dd">
								{bet.displayPaymentPerCombination}
							</td>
						</tr>
						<tr className="table--bets__tr">
							<td className="table--bets__dd">
								{t("ITEM.ADDITIONAL_TOTAL_STAKE")}
							</td>
							<td className="table--bets__dd">
								{bet.displayPayment}
							</td>
						</tr>
						{bet.handlingFeePercentage != null &&
							bet.handlingFeePercentage > 0 && (
								<tr className="table--bets__tr">
									<td className="table--bets__dd">
										{t("ITEM.ADDITIONAL_HANDLING_FEE", {
											0: bet.handlingFeePercentage.toFixed(),
										})}
									</td>
									<td className="table--bets__dd">
										{bet.displayHandlingFee}
									</td>
								</tr>
							)}
						<tr className="table--bets__tr">
							<td className="table--bets__dd">
								{t("ITEM.ADDITIONAL_MAX_COEFFICIENT")}
							</td>
							<td className="table--bets__dd">
								{bet.maxCoefficient.toFixed(2)}
							</td>
						</tr>
						{bet.gainBonusPercentage != null &&
							bet.gainBonusPercentage > 0 && (
								<tr className="table--bets__tr">
									<td className="table--bets__dd">
										{t("ITEM.ADDITIONAL_GAIN_BONUS", {
											0: bet.gainBonusPercentage.toFixed(
												2
											),
										})}
									</td>
									<td className="table--bets__dd">
										+ {bet.displayGainBonus}
									</td>
								</tr>
							)}
						{bet.gainTaxPercentage != null &&
							bet.gainTaxPercentage > 0 && (
								<tr className="table--bets__tr">
									<td className="table--bets__dd">
										{t("ADDITIONAL_GAIN_TAX", {
											0: bet.gainTaxPercentage.toFixed(2),
										})}
									</td>
									<td className="table--bets__dd">
										- {bet.displayGainTax}
									</td>
								</tr>
							)}
						<MaxGain />
						<Payment />
						<Gain />
						<Payout />

						<FiscalizationSection
							metadata={bet.metadata}
							currency={bet.currency}
						/>

						{bet.isCancellationAvailable && (
							<tr className="table--bets__tr table--bets__tr--cancel">
								<td
									className="table--bets__dd u-padd--x--xtny"
									colSpan={2}
								>
									<button
										className="btn btn--sml btn--danger"
										onClick={() => onBetCancel(bet)}
									>
										{t("ITEM.CANCEL_BET")}
									</button>
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</td>
		</tr>
	);
});
